var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegetablesPlate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Regular",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.999,
    cy: 12,
    r: 11.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.735 16.851a2.4 2.4 0 0 1-4.134 2.4l-4.541-6.8a1.5 1.5 0 0 1 .494-2.13L8.98 8.914a1.5 1.5 0 0 1 2.095.625ZM7.677 14.875l2.351-1.366M7.767 9.619 4.314 8.155M7.767 9.619l.438-3.725M12.374 6.8a3 3 0 0 1 5.25 2.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.418 9.036a3 3 0 0 0-2.169 1.512l5.25 2.9a3 3 0 0 0-1.643-4.287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetablesPlate);
export default __webpack_public_path__ + "static/media/vegetables-plate.af0067221e30b121f7d3e32e2acea172.svg";
export { ForwardRef as ReactComponent };